import React from 'react';

/**
 * A two-state slider.
 *
 * It is a <button role="switch">, not a checkbox dressed up with CSS: screen
 * readers announce "switch, on/off" and it is operable with space and enter for
 * free. `aria-checked` carries the state, so assistive tech never has to infer
 * it from the colour — which is also why the current state is written out as
 * text beside the track rather than left to the knob's position.
 *
 * `tone` picks which pair of colours the track uses. Availability is not the
 * same kind of state as a preference, so it does not borrow the accent: green
 * and amber mean something specific and are kept for it.
 */
export default function Switch({
  on,
  onChange,
  label,
  title,
  disabled = false,
  tone = 'accent',        // 'accent' | 'status'
  busy = false,
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!on}
      aria-label={title || label}
      title={title}
      disabled={disabled || busy}
      onClick={() => !disabled && !busy && onChange(!on)}
      className={`sw sw--${tone} ${on ? 'sw--on' : ''} ${disabled ? 'sw--off-duty' : ''}`}
    >
      <span className="sw-track" aria-hidden="true"><span className="sw-knob" /></span>
      <span className="sw-label">{label}</span>
    </button>
  );
}
